module.exports = __webpack_public_path__ + "img/рз_13.b7eddfcd.png";